import React from "react";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

import { OwnerSearch } from "./OwnerSearch";

function OwnerSearchControl({
  data,
  handleChange,
  path,
  label,
  required,
  errors,
}: ControlProps): JSX.Element {
  return (
    <OwnerSearch
      value={data}
      label={label}
      required={required}
      updateValue={(value: string) => handleChange(path, value)}
      errors={errors}
    />
  );
}

export default withJsonFormsControlProps(OwnerSearchControl);
